import { RestrictHeaderMovementEnd, RestrictHeaderMovementStart } from '@/events';
import React from 'react';
const SCROLL_THRESHOLD = 150;
const TOP_OF_PAGE_THRESHOLD = 30;
export function useHeaderScroll() {
    const restrictHeaderMovement = React.useRef(0);
    const previousYPosition = React.useRef(0);
    const [mode, setMode] = React.useState('expanded');
    const [isTopOfPage, setIsTopOfPage] = React.useState(true);
    React.useEffect(() => {
        const controller = new AbortController();
        window.addEventListener('scroll', () => {
            if (restrictHeaderMovement.current > 0) {
                return;
            }
            setIsTopOfPage(window.scrollY < TOP_OF_PAGE_THRESHOLD);
            const scrollAmount = Math.abs(previousYPosition.current - window.scrollY);
            if (scrollAmount >= SCROLL_THRESHOLD) {
                setMode(previousYPosition.current < window.scrollY ? 'condensed' : 'expanded');
                previousYPosition.current = window.scrollY;
            }
        }, { passive: true, signal: controller.signal });
        return () => controller.abort();
    }, []);
    React.useEffect(() => {
        const controller = new AbortController();
        window.addEventListener(RestrictHeaderMovementStart, () => {
            restrictHeaderMovement.current += 1;
        }, { signal: controller.signal });
        window.addEventListener(RestrictHeaderMovementEnd, () => {
            restrictHeaderMovement.current -= 1;
            previousYPosition.current = window.scrollY;
        }, { signal: controller.signal });
        return () => controller.abort();
    }, []);
    return { mode, isTopOfPage };
}
